import { render, staticRenderFns } from "./LeaderPage.vue?vue&type=template&id=73d2304e&scoped=true&"
import script from "./LeaderPage.vue?vue&type=script&lang=js&"
export * from "./LeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./LeaderPage.vue?vue&type=style&index=0&id=73d2304e&lang=scss&scoped=true&"
import style1 from "./LeaderPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2304e",
  null
  
)

export default component.exports